export default __webpack_public_path__ + "static/media/node.2f4837e6.jpg";